import { AimsCommonPopupEditorData } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { GetTextPipe } from 'src/app/pipes';
import { WasteDrum } from '../../viewWasteDrums.component';

@Component({
  selector: 'app-waste-drums-popup',
  templateUrl: './waste-drums-popup.component.html',
  styleUrls: ['./waste-drums-popup.component.css']
})
export class WasteDrumsPopupComponent implements OnInit {

  public formGroup: any;
  public drumToEdit: WasteDrum;
  public emps;
  public wasteDrumNumberLastFive;
  wasteContainerTypes;
  wasteTypes;
  sites;
  wasteStati;
  getTextPipe: GetTextPipe;


  constructor( contentData: AimsCommonPopupEditorData,) {
      this.drumToEdit = contentData.contentData.drumToEdit;;
      this.emps  = contentData.contentData.emps;
      this.formGroup = contentData.formGroup;
      this.wasteDrumNumberLastFive = this.drumToEdit.wasteDrumNumber.substring(7);
      this.wasteContainerTypes = contentData.contentData.wasteContainerTypes;
      this.wasteTypes = contentData.contentData.wasteTypes;
      this.sites = contentData.contentData.sites;
      this.wasteStati = contentData.contentData.wasteStati;
      this.getTextPipe = contentData.contentData.getTextPipe;

      this.formGroup.addControl('wasteDrumNumberLastFive', new FormControl(this.wasteDrumNumberLastFive, Validators.required));
      this.formGroup.addControl('containerTypeId', new FormControl(this.drumToEdit.containerTypeId, Validators.required))
      this.formGroup.addControl('wasteTypeId', new FormControl(this.drumToEdit.wasteTypeId, Validators.required))
      this.formGroup.addControl('siteId', new FormControl(this.drumToEdit.siteId, Validators.required))
      this.formGroup.addControl('issuedDate', new FormControl(this.drumToEdit.issuedDate, Validators.required))
      this.formGroup.addControl('offSiteDate', new FormControl(this.drumToEdit.offSiteDate))
      this.formGroup.addControl('accumulationDate', new FormControl(this.drumToEdit.accumulationDate))
      this.formGroup.addControl('issuedById', new FormControl(this.drumToEdit.issuedById, Validators.required))
      this.formGroup.addControl('wasteCurrentStatusId', new FormControl(this.drumToEdit.wasteCurrentStatusId, Validators.required))
      this.formGroup.addControl('sealedDate', new FormControl(this.drumToEdit.sealedDate))
      this.formGroup.addControl('sealedById', new FormControl(this.drumToEdit.sealedById))
      this.formGroup.addControl('closedOutDate', new FormControl(this.drumToEdit.closedOutDate))
      this.formGroup.addControl('closedOutById', new FormControl(this.drumToEdit.closedOutById))
  }

  updateWasteDrumNumberSite(event) {
    let siteCode = this.getTextPipe.transform(event.value, 'siteId', 'siteCode', this.sites);
    this.drumToEdit.wasteDrumNumber = siteCode + this.drumToEdit.wasteDrumNumber.substring(3);
  }

  updateAccumDate($event: Date) {
    this.drumToEdit.offSiteDate = moment($event).add(1, 'year').toDate();
    this.formGroup.patchValue({ 'offSiteDate': this.drumToEdit.offSiteDate });
  }

  ngOnInit(): void {
  }

}
